import { Modal } from '@trackman/web-shared-components';
import React from 'react';
import styled from 'styled-components';
import { acceptgreen } from 'styles/Colors';

export const StyledModal = styled((props) => <Modal {...props} />)`
  text-align: center;

  .header {
    .close {
      display: none;
    }
  }

  div[class*='-closeIcon-'] {
    display: none;
  }
`;

export const Content = styled.div`
  padding: 20px !important;
`;

export const IconAndTextRow = styled.div`
  display: flex;
  justify-content: center;
`;

export const IconWrapper = styled.div`
  margin-right: 10px;
  svg {
    position: relative;
    bottom: 3px;
  }
`;

export const CheckIconWrapper = styled.span`
  svg {
    position: relative;
    bottom: 5px;
    path {
      fill: ${acceptgreen};
    }
  }
`;

export const Text = styled.div`
  font-family: Lato;
  font-size: 15px;
`;
